import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle",
  "use": "icon-circle-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol viewBox=\"0 0 8 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-circle\"><circle cx=\"4\" cy=\"4\" r=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol